import React from "react";

const Input = ({ smallTitle, placeholder, value, onChange }) => {
  return (
    <>
      <label htmlFor="">{smallTitle}</label>
      <input
        type="text"
        placeholder={placeholder}
        style={{ display: "block" }}
        value={value}
        onChange={onChange}
      />
    </>
  );
};

export default Input;
